/**
 * Combat helmet. The head is where a critical is worth the most, so this is the plate that changes
 * how a firefight ends rather than how long it lasts.
 */

import type { ArmorItem } from '@/sim/items/itemContract';

export const COMBAT_HELMET = {
  id: 'combatHelmet',
  kind: 'armor',
  label: 'Combat helmet',
  description: 'Ballistic shell, torn liner. The previous owner had one bad afternoon in it.',
  rarity: 'uncommon',
  weightKg: 1.8,
  stackLimit: 1,
  equip: {
    slots: ['head'],
    statDeltas: { perception: -1 },
    armor: { threshold: 3, rating: 20 },
    damageModifiers: [],
  },
} as const satisfies ArmorItem;
